import firebase from '../constants/firebase';

const getContent = async items => {
  return Promise.all(
    items.map(async d => {
      return {
        ...d.data(),
        id: d.id,
      };
    })
  );
};

export const get = async matrixId => {
  const db = firebase.firestore();

  let querySnapshot = db
    .collection('activeMatrices')
    .where('id', '==', matrixId);

  const docs = [...(await querySnapshot.get()).docs];

  return getContent(docs);
};

export const save = async inUse => {
  const db = firebase.firestore();

  // Create or update folder
  const doc = await db.collection('activeMatrices').doc(inUse.id);

  doc.set(inUse);
};
